import {
  IoCheckmarkCircleOutline,
  IoCloseCircleOutline,
  IoTimeOutline,
} from 'react-icons/io5';

import { getPreviousMonthPeriod } from 'utils/date/convertDateUtil';

export const bilingPriceInitConst = {
  title: '청구 요금',
  total: '0',
  date: getPreviousMonthPeriod(),
  paymentStatus: true,
};

export const billingListHeaderConst = [
  {
    text: '상태',
    value: 'paymentStatus',
  },
  {
    text: '월',
    value: 'paymentMonth',
  },
  { text: '총 금액 (VAT 포함)', value: 'paymentTotal' },
  { text: '이용 기간', value: 'paymentUsageDate' },
  {
    text: '결제일',
    value: 'paymentDate',
  },
];

export const billingStatusConst = [
  {
    type: 'cancel',
    name: '미납',
    variant: 'red',
    value: 0,
    icon: IoCloseCircleOutline,
    color: 'red900',
    status: '실패',
  },
  {
    type: 'done',
    name: '완료',
    variant: 'primary',
    value: 1,
    icon: IoCheckmarkCircleOutline,
    color: 'primary',
    status: '완료',
  },
  {
    type: 'scheduled',
    name: '청구',
    variant: 'yellow',
    value: 2,
    icon: IoTimeOutline,
    color: 'yellow900',
    status: '예정',
  },
];
export const billingDetailPageConst = billingStatusConst.map((el) => el.type);

export const bilingAppInfoHeaderConst = [
  { text: '상품명', value: 'priceName' },
  { text: 'APP 이름', value: 'appName' },
  { text: 'APP 생성일', value: 'appCreateDt' },
  { text: '이용 기간', value: 'paymentAppPeriodDt' },
  { text: '정지 기간', value: 'paymentAppStopDt' },
  { text: '이용 금액', value: 'paymentAppCost' },
  {
    text: '할인 금액',
    value: 'paymentAppDiscount',
  },
  { text: '총 금액', value: 'paymentAppTotal' },
];

export const bilingAppInfoSubHeaderConst = {
  add: [
    { text: '이용 금액', value: 'apiCost' },
    {
      text: '할인 금액',
      value: 'apiDisCount',
    },
    { text: '총 금액', value: 'apiTotal' },
  ],
  common: [
    { text: 'API', value: 'apiName' },
    {
      text: '과금 기준 / 호출 수',
      value: 'chargePerCall',
    },
    { text: '사용량', value: 'totalCount' },
  ],
};

const billingCardInfoCommonConst = [
  {
    title: '결제 카드',
    cont: '현대 - 374664******802(법인)',
    name: 'cardInfo',
  },
  {
    title: '결제일',
    cont: '2025-06-05 05:00:01',
    name: 'paymentDt',
  },
];

export const billingCardInfoConst = {
  no: billingCardInfoCommonConst.slice(0, 1),
  done: [
    ...billingCardInfoCommonConst,
    {
      title: '부가세',
      cont: 345000,
      name: 'paymentVat',
    },
    {
      title: '결제 상태',
      cont: '완료',
      name: 'paymentStatus',
    },
  ],
  scheduled: [
    ...billingCardInfoCommonConst,
    {
      title: '결제 상태',
      cont: '예정',
      name: 'paymentStatus',
    },
  ],
  cancel: [
    ...billingCardInfoCommonConst,
    {
      title: '재 결제 예정일',
      cont: '2025-07-05 05:00:01',
      name: 'paymentRetryDate',
    },
    {
      title: '결제 상태',
      cont: '실패',
      name: 'paymentStatus',
    },
  ],
};

export const billingDetailDataConst = {
  payment: {
    paymentId: 9,
    paymentStatus: true,
    paymentStartDt: '2025-05-01 00:00:00',
    paymentEndDt: '2025-05-31 23:59:59',
    paymentVat: 345000,
    paymentDt: '2025-06-05 05:00:01',
    paymentRetryDate: null,
    paymentErrorMessage: null,
    paymentTotalAmount: 3795000,
    paymentReceipt:
      'https://dashboard.tosspayments.com/receipt/redirection?transactionId=tbill202506050500012iKC2&ref=PX',
  },
  card: {
    cardId: 7,
    cardCompany: '현대',
    cardNumber: '374664******802',
    cardStatus: '법인',
  },
  paymentAppList: [
    {
      app: {
        appId: 67,
        appName: '체험판',
        appCreateDt: '2025-05-09 00:50:15.0',
      },
      price: {
        priceId: 99,
        priceName: 'FREE',
      },
      paymentApp: {
        paymentAppId: 65,
        paymentAppPeriodDt: '2025-05-08~2025-05-31',
        paymentAppStopDt: null,
        paymentAppCost: 0,
        paymentAppDiscount: 0,
        paymentAppTotal: 0,
      },
      paymentApiList: [],
    },
    {
      app: {
        appId: 34,
        appName: '라이선스',
        appCreateDt: '2025-04-02 22:58:08.0',
      },
      price: {
        priceId: 4,
        priceName: 'ENTERPRISE',
      },
      paymentApp: {
        paymentAppId: 34,
        paymentAppPeriodDt: '2025-05-01~2025-05-31',
        paymentAppStopDt: null,
        paymentAppCost: 0,
        paymentAppDiscount: 0,
        paymentAppTotal: 0,
      },
      paymentApiList: [],
    },
    {
      app: {
        appId: 33,
        appName: '정액제',
        appCreateDt: '2025-04-02 22:58:03.0',
      },
      price: {
        priceId: 2,
        priceName: 'SMART100',
      },
      paymentApp: {
        paymentAppId: 33,
        paymentAppPeriodDt: '2025-05-01~2025-05-31',
        paymentAppStopDt: null,
        paymentAppCost: 3500000,
        paymentAppDiscount: 1050000,
        paymentAppTotal: 3450000,
      },
      paymentApiList: [
        {
          apiType: 'routeNormal',
          apiName: '경로 탐색',
          totalCount: 1010000,
          apiCharge: 3.5,
          apiCost: 3535000,
          apiDisCount: 1050000,
          apiTotal: 2485000,
        },
      ],
    },
    {
      app: {
        appId: 32,
        appName: '종량제',
        appCreateDt: '2025-04-02 22:57:58.0',
      },
      price: {
        priceId: 1,
        priceName: 'START',
      },
      paymentApp: {
        paymentAppId: 66,
        paymentAppPeriodDt: '2025-05-08~2025-05-08',
        paymentAppStopDt: '2025-05-09~2025-05-31',
        paymentAppCost: 0,
        paymentAppDiscount: 0,
        paymentAppTotal: 0,
      },
      paymentApiList: [],
    },
  ],
};
